// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__mYcj_","item":"styles_item__t_xNR","tokenTitle":"styles_tokenTitle__elmpX","marquee":"styles_marquee__SDoyS"};